import React from 'react';

const VideoThumbnail = ({ previewUrl, videoUrl, poster, title, className }) => {
  return (
    <img
      src={poster || previewUrl || ''}
      alt={title || 'video'}
      className={className}
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      loading="lazy"
    />
  );
};

export default VideoThumbnail;
